
export enum CustomerFunctionCd {
	BILL_TO = 'Bill-To',
	CORPORATE = 'Corporate',
	PICKUP_OR_DELIVERY = 'PickupOrDelivery'}

